import React from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import Navbar from './components/navbar';
import About from './components/about';
import Home from './components/home';
import NoteState from './context/notes/noteState';
import ContactUs from './components/contactUs';
import '../src/App.css'
import Footer from './components/footer';
import ServicesMain from './components/servicesMain';
import ServicePreview from './components/servicepreview';
import OurWork from './components/servicesMain copy';
import WhoWeAre from './components/servicesMain copy 2';
export default function App() {

    return (
        <div>

            <Router>
                <NoteState>

                    <div style={{ overFlow: 'visible' }}>

                        <Navbar />

                    </div>
                    <div style={{marginTop:'96px'}}>
                        <Switch>
                            <Route exact path="/">
                                <Home />
                            </Route>
                            <Route exact path="/about">
                                <About />
                            </Route>
                            <Route exact path="/contactus">
                                <ContactUs />
                            </Route>
                            <Route exact path="/whoweare">
                                <WhoWeAre />
                            </Route>
                            <Route exact path="/services">
                                <ServicesMain />
                            </Route>
                            <Route exact path="/ourwork">
                                <OurWork />
                            </Route>
                            <Route exact path="/services/preview">
                                <ServicePreview />
                            </Route>


                        </Switch>
                    </div>
                    <Footer />
                </NoteState>
            </Router>

        </div>
    )
}


// WEBPACK FOOTER //
// ./src/App.jsx